/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */

import { fromJS } from 'immutable';
import { TOGGLE_CASINO_SOUNDS } from './actions';
import { setCasinoSoundsCookie, getCasinoSoundsCookie } from 'utils/cookies';

const soundCookie = getCasinoSoundsCookie();
const cookieUndefined = typeof soundCookie === 'undefined';
const soundOn = soundCookie === 'true';

// The initial state of the App
const initialState = fromJS({
  casinoSoundsOn: soundOn || cookieUndefined
});

function appReducer(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_CASINO_SOUNDS:
      const soundsOn = !state.get('casinoSoundsOn');
      setCasinoSoundsCookie(soundsOn);

      return state.set('casinoSoundsOn', soundsOn);

    default:
      return state;
  }
}

export default appReducer;



// WEBPACK FOOTER //
// ./src/containers/App/reducer.js